export const ClientContactsListingGetters = {
  ClientContactsList: 'getClientContactsList',
  ClientContactsListSortBy: 'getClientContactsListSortby',
  ClientContactsListSortDirection: 'getClientContactsListSortDirection',
  ClientContactsPerPage: 'getClientContactsListPerPage',
  ClientContactsListingOffset: 'getClientContactsListOffset',
  ClientContactsListingRecordCount: 'getClientContactsListRecordCount',
  ClientContactActiveInactive: 'getClientContactsListActiveInactive'
};

export const ClientContactsListingMutations = {
  SetClientContactsLoading: 'setClientContactsListLoading',
  SetClientContactsList: 'setClientContactsList',
  SetClientContactsSortOrder: 'setClientContactsSortOrder',
  SetClientContactPaginationParameters: 'setClientContactsPagination',
  SetClientContactsRecordCount: 'setClientContactsRecordCount',
  SetClientContactsActiveInactive: 'setClientContactsActiveInactive',
  SetSearchParam: 'setClientContactsSearchParam',
  ResetClientContactsPaginationOffset: 'resetClientContactsPaginationOffset'
};

export const ClientContactsListingActions = {
  RetrieveContactsList: 'updateClientContactsListing',
  UpdateClientContactsSortOrder: 'updateClientContactsSortOrder',
  UpdatePaginationParams: 'updatePaginationParams',
  RetrieveContactsListCount: 'updateClientContactsListCount',
  UpdateActiveInactive: 'updateFilter',
  ExportContactsListExcel: 'downlaodClientContactsExcel',
  UpdateSearchList: 'updateSearchListClientContacts'
};
